import { paths } from 'src/routes/paths';

export const HOST_API = process.env.REACT_APP_HOST_API;
export const ASSETS_API = process.env.REACT_APP_ASSETS_API;

export const MAPBOX_API = process.env.REACT_APP_MAPBOX_API;

export const PATH_AFTER_LOGIN = paths.home;
